import { Component, Input } from "@angular/core";

@Component({
  selector: "app-spec-table",
  templateUrl: "./spec-table.component.html",
  styleUrls: ["./spec-table.component.scss"],
})
export class SpecTableComponent {
  @Input() headerLabel = "Specifications";
  @Input() columns: string[] = [];
  @Input() rows: { label: string; values: string[]; rowspan?: number }[] = [];
}
